import React, { useState, useEffect } from 'react'
import Router from 'next/router'
import qs from 'qs'
import { findResultsState } from 'react-instantsearch-dom/server'
import { searchClient } from 'lib/algolia'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import Search from 'components/Search'
import { usePageView } from 'hooks'
import { getServerSideWrapper } from 'utils'

const SearchPage = ({ resultsState, initialSearchState }) => {
  usePageView((ga) => {
    ga.customDimensions.setPageType('Search')
  })

  // actual state of the search bar to be synced up with the url params
  const [searchState, setSearchState] = useState(initialSearchState)

  // a record of the initial search props passed down
  // used for comparison to know when the search state passed via props have changed
  const [propPassedSearchState, setPropPassedSearchState] = useState(initialSearchState)

  // state of the latest NodeJS.Timeout ID returned by setTimeout
  // for pushing a new search url upon search state update
  const [debouncedFunctionState, setDebouncedFunctionState] = useState(null)

  useEffect(() => {
    // if the props have changed, the url query changed due to a component managed
    // outside of this component (such as the header drop down search bar)
    // Synchronize search state values to avoid bugs
    if (propPassedSearchState.query !== initialSearchState.query) {
      setSearchState(initialSearchState)
      setPropPassedSearchState(initialSearchState)
    }
  }, [initialSearchState, propPassedSearchState.query])

  const createURL = (state) => `?${qs.stringify(state)}`
  const searchStateToUrl = (state) => (state ? `${window.location.pathname}?${qs.stringify(state)}` : '')
  const onSearchStateChange = (state) => {
    if (debouncedFunctionState) {
      clearTimeout(debouncedFunctionState)
    }
    const newDebounceFunctionID = setTimeout(async () => {
      const href = searchStateToUrl(state)
      Router.push(href, href, { shallow: true })
    }, 700)
    setDebouncedFunctionState(newDebounceFunctionID)
    setSearchState({ ...state, query: decodeURIComponent(state.query || '') })
  }
  return (
    <SiteLayout>
      <Head
        title='Search Barstool Sports | Barstool Sports'
        description='Search Barstool Sports for the latest blogs, videos and podcasts about sports betting and more.'
      />
      <Search
        searchState={searchState}
        resultsState={resultsState}
        onSearchStateChange={onSearchStateChange}
        createUrl={createURL}
      />
    </SiteLayout>
  )
}

export const getServerSideProps = getServerSideWrapper(async ({ query }) => {
  const initialSearchState = { ...query }
  const resultsState = await findResultsState(Search, { indexName: 'BarstoolSports', initialSearchState, searchClient })
  resultsState.state = resultsState.state ? JSON.parse(resultsState.state.toString()) : {}
  return {
    // Force json for resultsState which does not serialize correctly on Next 9.5
    resultsState: JSON.parse(JSON.stringify(resultsState)),
    initialSearchState
  }
})

export default SearchPage
